import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const InputGroup = ({
  buttonText, buttonLeftSide, placeholder, onValidate, minLength, maxLength,
  uppercase = false, clearAndDisable = true, small = false, marginBottom = true
}) => {
  const [inputValue, setInputValue] = useState('');
  const [inputProps, setInputProps] = useState({});
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const inputProps = {};
    inputProps['placeholder'] = placeholder;
    inputProps['aria-label'] = placeholder;
    inputProps['value'] = inputValue;
    if (minLength) {
      inputProps['minLength'] = minLength;
    }
    if (maxLength) {
      inputProps['maxLength'] = maxLength;
    }
    setInputProps(inputProps);
  }, [inputValue, placeholder, minLength, maxLength]);

  const onChange = (e) => {
    const value = uppercase ? e.target.value.toUpperCase() : e.target.value;
    setEnabled(checkValidation(value));
    setInputValue(value);
  };

  const sendInputValue = () => {
    onValidate(inputValue);
    clearIfNeeded();
  };

  const handleEnterKey = (e) => {
    if (e.target.value && e.keyCode === 13) {
      sendInputValue();
    }
  };

  const clearIfNeeded = () => {
    if (clearAndDisable) {
      setInputValue('');
      setEnabled(false);
    }
  };

  const checkValidation = (value) => {
    if (value === '') {
      return false;
    }
    if (minLength && value.length < +minLength) {
      return false;
    }
    if (maxLength && value.length > +maxLength) {
      return false;
    }
    return true;
  };

  const InsideButton = () => (
    <div className={`input-group-${buttonLeftSide ? 'prepend' : 'append'}`} data-test-id="btn-div">
      <button type="button" className="btn inputGroup-btn tu-btn" disabled={!enabled} onClick={sendInputValue} data-test-id="btn">
        {uppercase ? buttonText.toUpperCase() : buttonText}
      </button>
    </div>
  );

  return (
    <div className={`mil-input-group input-group ${small ? 'input-group-sm' : ''} ${marginBottom ? 'mb-3' : ''}`} data-test-id="input-group">
      {buttonLeftSide &&
        <InsideButton />
      }
      <input type="text" className={`form-control tu-input${uppercase ? ' text-uppercase' : ''}`}
        data-test-id="input"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleEnterKey}
        onChange={onChange}
        value={inputValue}
        {...inputProps}
      />
      {!buttonLeftSide &&
        <InsideButton />
      }
    </div >
  );
};

InputGroup.propTypes = {
  onValidate: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLeftSide: PropTypes.bool,
  uppercase: PropTypes.bool,
  placeholder: PropTypes.string,
  clearAndDisable: PropTypes.bool,
  small: PropTypes.bool,
  marginBottom: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number
};

export default InputGroup;
